import { ViewChild, ViewEncapsulation } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuthenticationService } from '@app/_services';
import { NgbCarousel, NgbCarouselConfig, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { WelcomeHomepageModalComponent } from '../welcome-homepage-modal/welcome-homepage-modal.component';

@Component({
  selector: 'app-new-homepage-landing',
  templateUrl: './new-homepage-landing.component.html',
  styleUrls: ['./new-homepage-landing.component.less'],
  encapsulation : ViewEncapsulation.None
})
export class NewHomepageLandingComponent implements OnInit{
  isActive = false;
  posIni: any;
  @ViewChild(NgbCarousel, { static: true }) carousel: NgbCarousel;
  images = [944, 1011, 984].map((n) => `https://picsum.photos/id/${n}/900/500`);
  constructor(private route: ActivatedRoute,
    private auth: AuthenticationService,
    config: NgbCarouselConfig,
    private modalService: NgbModal) { }

  ngOnInit(): void {
    this.checkAuth();
  }

  smoothScroll = (id: string) => {
    const element = document.getElementById(id);
    element.scrollIntoView({ behavior: "smooth" });
  }

  videoModal(content: any) {
    this.modalService.open(content, {
      size: "lg",
      ariaLabelledBy: "modal-basic-title",
      windowClass: "video-modal",
    });
  }

  checkAuth() {
    this.route.queryParams.subscribe((params) => {
      if (params.user) {
        this.auth.postLogin(params.user, params.deepLink);
      } else {
        // this.router.navigate(['/']);
      }
    });
  }

  openWelcomeDialog(){
    const locatorModalRef = this.modalService.open(
      WelcomeHomepageModalComponent,
      {
        ariaLabelledBy: "modal-basic-title",
        backdrop: "static",
        windowClass: "confirm-modal",
        centered: true,
        size: "lg",
      }
    );
  }

  move(pos:number) {
    const offset = this.posIni - pos;
    if (offset < -100) this.carousel.prev()

    if (offset > 100) this.carousel.next();
  }

  changePage(data: any) {
    this.carousel.select(data);
  }
}
